import request from "./base";
const path = "/api/tags";

export default {
  get: function ({index}) {
    return request().get(path + "/", {
      params: {index}
    });
  },
  create: function ({index, title}) {
    return request().post(path + "/", {index, title});
  },
  assign: function ({index, tag_ids, filter}) {
    return request().post(path + "/assign", {index, tag_ids, filter});
  },
  delete: function (params) {
    return request().delete(path + "/", {data: params});
  },
};
